module.exports = __webpack_public_path__ + "media/images/icons/outlined/yahoo-a499143ff9c19faf619a770b3d26db12.svg";